import { render, staticRenderFns } from "./WarningAlert.vue?vue&type=template&id=58dae463&scoped=true"
import script from "./WarningAlert.vue?vue&type=script&lang=js"
export * from "./WarningAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dae463",
  null
  
)

export default component.exports